import React, { useState } from 'react';
import { Collapse, Card, CardBody } from 'reactstrap';
import { FaChevronDown } from 'react-icons/fa';
import './Accordion.css';
import parse from "react-html-parser";

const Accordion = ({ title, children,titleClass }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <div className="accordion-item">
      <div className="accordion-header" onClick={toggle}>
        <span className="accordion-title">{parse(title)}</span>
        <FaChevronDown className={`chevron-icon ${isOpen ? 'rotate' : ''}`} />
      </div>
      <Collapse isOpen={isOpen}>
        <Card>
          <CardBody>
            {children}
          </CardBody>
        </Card>
      </Collapse>
    </div>
  );
};

export default Accordion;
